// extracted by mini-css-extract-plugin
export default {"size":"_1duec5zuiRUo83p89oK8jC","unitDetails":"_2YTbZYDJKWW023QoDpsunD","contentToggle":"Xb40M3vne_6f8tj8s5aMJ","unitsCount":"_2ftOfpQ3LPDnz1qz1hgkWJ"};